import { nanoid } from 'nanoid'

/**
 * @property {String} id - id of the table item
 */

export default class SimpleTableItem {
  constructor(removed = false) {
    this.id = nanoid()

    /**
     * Whether the table item is removed or not (only relevant if removable prop active)
     * @type {Boolean}
     */
    this.removed = removed
  }
}
